/** localStorage key for "last seen" service request count (per company). Clears badge after they open the tab. */
export const PORTAL_FIX_REQUESTS_SEEN_KEY = (companyId: string) => `portal_fix_requests_seen_${companyId}`;
